import { render, staticRenderFns } from "./NpaView.vue?vue&type=template&id=82c1ddfa&scoped=true"
import script from "./NpaView.vue?vue&type=script&lang=js"
export * from "./NpaView.vue?vue&type=script&lang=js"
import style0 from "./NpaView.vue?vue&type=style&index=0&id=82c1ddfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c1ddfa",
  null
  
)

export default component.exports